export default __webpack_public_path__ + "static/media/Microsoft Edge.d50b4644.svg";